const IconPerfilSvg = (props: any) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 22.4999H4V20.4999C4 19.1739 4.52678 17.9021 5.46447 16.9644C6.40215 16.0267 7.67392 15.4999 9 15.4999H15C16.3261 15.4999 17.5979 16.0267 18.5355 16.9644C19.4732 17.9021 20 19.1739 20 20.4999V22.4999ZM12 13.4999C11.2121 13.4999 10.4319 13.3447 9.7039 13.0432C8.97595 12.7417 8.31451 12.2997 7.75736 11.7426C7.20021 11.1854 6.75825 10.524 6.45672 9.79604C6.15519 9.06809 6 8.28787 6 7.49994C6 6.71201 6.15519 5.93179 6.45672 5.20384C6.75825 4.47588 7.20021 3.81445 7.75736 3.2573C8.31451 2.70015 8.97595 2.25819 9.7039 1.95666C10.4319 1.65513 11.2121 1.49994 12 1.49994C13.5913 1.49994 15.1174 2.13208 16.2426 3.2573C17.3679 4.38252 18 5.90864 18 7.49994C18 9.09124 17.3679 10.6174 16.2426 11.7426C15.1174 12.8678 13.5913 13.4999 12 13.4999Z"
        fill="url(#paint0_linear_1261_1348)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1261_1348"
          x1="12"
          y1="1.49994"
          x2="12"
          y2="22.4999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FFFC7" />
          <stop offset="1" stopColor="#017849" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default IconPerfilSvg
